var $ = jQuery;

// TODO: make this function a universal option for scrolling elements into and out of view
// e.g. show chat on scroll, don't scroll back off. plus show/hide navbar / toggle in the same site.
// TODO: add more options

export default function hide_on_scroll($el) {
  if (!$el) return;
  var didScroll;
  var st = $(window).scrollTop();
  var lastScrollTop = st;
  var delta = 100;
  var elHeight = $el.outerHeight();
  $(window).on('scroll', function (event) {
    didScroll = true;
  });
  setInterval(function () {
    if (!didScroll) return;
    didScroll = false;
    st = $(window).scrollTop();
    if (Math.abs(lastScrollTop - st) <= delta) return;
    if (st > lastScrollTop && st > elHeight) {
      // Scroll Down
      $el.attr('data-visible', 'false');
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $el.attr('data-visible', 'true');
      }
    }
    lastScrollTop = st;
  }, 250);
}